import { useQueryClient } from "@tanstack/react-query"

import { useNetworksStateContext } from "@l2r-front/l2r-networks"
import { l2rApiAxiosInstance as axiosInstance } from "@l2r-front/l2r-query"

import { invalidateDocumentsList, invalidateDocumentProject, invalidateAttachedObject } from "../cacheUtils"
import { documentQueryKeys } from "../queries/queryKeys"

import { useDocumentMutation } from "./useDocumentMutation"

export function useDocumentUpdate(
    document,
    queryParameters,
    config = {},
) {
    const url = `documents/${document?.uuid}/`
    const queryClient = useQueryClient()
    const { selectedNetwork } = useNetworksStateContext()

    const axiosFn = (url, values) => {
        const formData = new FormData()
        Object.entries(values).forEach(([key, value]) => {
            if (Array.isArray(value)) {
                formData.append(`${key}`, JSON.stringify(value))
            } else {
                formData.append(key, value)
            }
        })


        const headers = { "Content-Type": "multipart/form-data" }

        return axiosInstance.patch(url, formData, {
            headers: headers,
        })
    }

    return useDocumentMutation(
        url,
        axiosFn,
        {
            ...queryParameters,
        },
        {
            ...config,
            onSuccess: (data) => {
                queryClient.invalidateQueries({ queryKey: documentQueryKeys.detail(document.uuid) })
                queryClient.invalidateQueries({ queryKey: documentQueryKeys.authors() })

                invalidateDocumentProject(queryClient, selectedNetwork)
                invalidateDocumentsList(queryClient, selectedNetwork)
                invalidateAttachedObject(queryClient, data)

                config.onSuccess?.(data)
            },
        },
    )
}
